<template>
  <div>
    <div class="tbd-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="searchAjax" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="searchParams" ref="loginform" label-width="100px">

          <el-form-item label="微信昵称">
            <el-input v-model="searchParams.nickname" placeholder="请输入" clearable></el-input>
          </el-form-item>

        </el-form>
      </topSearchForm>
      <div class="order-no">
        订单编号：{{ $route.query.orderNo }}
      </div>
      <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading='listLoading'>
        <el-table-column label="序号" width="50px;" type="index" fixed="left"></el-table-column>
        <el-table-column label="微信昵称" min-width="200px;" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="wx-name">
              <img v-if="scope.row.imgUrl" :src="scope.row.imgUrl" alt="" />
              <p>{{ scope.row.nickname }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="停留时长" property="totalDuration">
          <template slot-scope="scope">
            {{ scope.row.totalDuration == '00:00:00' ? '-' : scope.row.totalDuration }}
          </template>
        </el-table-column>
        <el-table-column label="用户行为" property="behaviorRecordStr" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="退出节点" property="exitBehaviorStr"></el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
        :layout="$tools.pageLayout" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
//当前实例组件
import topSearchForm from "@/components/topSearchForm.vue";
import { common, pageTool } from "@/api/mixins";

export default {
  components: {
    topSearchForm,
  },
  mixins: [common, pageTool],
  data: () => ({
    statisticsInfo: {}
  }),

  created() {
    this.initListAjax("/master/productVisitor/queryOrderVisitor");
  },

  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    setListParams(params){
      params.orderNo = this.$route.query.orderNo;
    },

    // 导出
    exportToExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$tools.daochu("/master/productVisitor/exportOrderVisitor", params, 'PUT');
    },
  },
};
</script>

<style lang="scss" scoped>
.tbd-content {
  background: #ffffff;
  padding: 20px 30px 30px 30px;
}

// .el-pagination {
//   margin-top: 50px;
// }
.order-no{
  font-size: 13px;
  margin-top: 10px;
}
.list-table {
  margin-top: 20px;
  .cell {
    text-align: center;
  }
  .wx-name{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    img{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    p{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

</style>